/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type useFetchWithAuth_local = {
    readonly accessToken: string | null;
    readonly " $refType": "useFetchWithAuth_local";
};
export type useFetchWithAuth_local$data = useFetchWithAuth_local;
export type useFetchWithAuth_local$key = {
    readonly " $data"?: useFetchWithAuth_local$data;
    readonly " $fragmentRefs": FragmentRefs<"useFetchWithAuth_local">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useFetchWithAuth_local",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessToken",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '1200cd8f390eef12bbbb74f2e826683d';
export default node;
